<div class="notification-dialog">
  <h2 mat-dialog-title>{{data.title}}</h2>
  <mat-dialog-content class="mat-typography">
    {{data.content}}
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    @if (data.isConfirm) {
    <button mat-button (click)="onCancel()" [mat-dialog-close]="true" cdkFocusInitial>Cancel</button>
    <button mat-button (click)="data.confirmCallback()" [mat-dialog-close]="true">Confirm</button>
    }@else{
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
    }
  </mat-dialog-actions>
</div>
